export const hr = () => `<hr />`
